import { useEffect } from "react";

import useMainLayoutStore from "../stores/mainLayoutStore";

export default function useBomUsageLimitVisibility(visible = true) {
  useEffect(() => {
    useMainLayoutStore.getState().setShowBomUsageLimit(visible);

    return () => {
      useMainLayoutStore.getState().setShowBomUsageLimit(true);
    };
  }, [visible]);
}
